import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import placeholder from '@/assets/placeholderImage.webp';
import voicecal from '@/assets/voicecall.png';
import videocal from '@/assets/videoCall.png';
import ellipse from '@/assets/ellipse.svg';
import ChatIllusttaions from '@/assets/chatIllustration.webp';
import { useSearchParams } from 'react-router-dom';
import InputEmoji from 'react-input-emoji';
import { Button } from '@/components/Elements';
import { Image } from '@/components/Elements/Image';
import { isVideo } from '@/hooks/useSelectMultipleFile';
import { Fade, Menu, MenuItem } from '@mui/material';

type ChatItemProps = {
  id: number;
  sid: string;
  name: string;
  image: string;
  time: string;
  last_message: string;
  active?: boolean;
};
type MessageItemProps = {
  message: string;
  name?: string;
  time?: string;
  image?: string;
  date?: string;
  media?: string;
  mediaName?: string;
  messageTime?: string;
  seen?: boolean;
  profileImg?: string;
  msgType?: string;
};

type MessageItemContanerProps = {
  type: 1 | 2;
  message: string;
  name?: string;
  image?: string;
  date?: string;
  media?: string;
  mediaName?: string;
  messageTime?: string;
  seen?: boolean;
  profileImg?: string;
  videoThumbnail?: string;
  msgType?: string;
};
type HeaderProps = {
  name: string | undefined;
  image: string | undefined;
  id: number | undefined;
  phoneNumber: string | undefined;
};

type SendMessageInputTypes = {
  handdleSendMessage: (message: string) => void;
};
const makeUrl = (path: string) => {
  return 'env?.API_URL + path;';
};

export const ChatItem = (props: ChatItemProps) => {
  const [searchParams] = useSearchParams();
  const activeId: string | null = searchParams.get('id');
  const { id, sid, name, image, time, last_message, active } = props;
  return (
    <Link
      to={`/app/chats/message?id=${id}&&sid=${sid}`}
      className={`w-full flex items-center  p-2 rounded-md hover:bg-blue-300 ${
        activeId && parseInt(activeId) == id ? 'bg-blue-600' : ''
      }`}
    >
      <div className="w-10 h-10 bg-blue-900 flex items-center justify-center rounded-full">
        <img
          className="w-full h-full rounded-full"
          src={image && image !== '' && image !== 'None' ? makeUrl(image) : placeholder}
        />
      </div>
      <div className="flex flex-col gap-[2px] ml-2">
        <h1 className="font-bold">{name}</h1>
        <p className="text-sm font-light">{last_message}</p>
        <span className="text-[8px]">{time}</span>
      </div>
    </Link>
  );
};

export const ChatHeader = (props: HeaderProps) => {
  const { name, image, id, phoneNumber } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const message = 'Hello, I need assistance.'; // optional message  const whatsappUrl = `whatsapp://send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
  //const whatsappUrl = `whatsapp://send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <div className="chat-head-box flex justify-between items-center">
      <div className="w-full flex items-center py-2">
        <div className="w-12 h-12 bg-blue-900 flex items-center justify-center rounded-full">
          <img
            className="w-full h-full rounded-md chat-head-ico"
            style={{ objectFit: 'cover' }}
            src={image ? image : placeholder}
          />
        </div>
        <div className="flex flex-col gap-[2px] ml-2">
          <h5 className="font-bold f-14 mb-0">{name}</h5>
        </div>
      </div>
      <div className="chat-right-box flex items-center gap-2">
        <a href={`tel:${phoneNumber}`}>
          <img src={voicecal} className="voice-call" />
        </a>
        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
          <img src={videocal} className="voice-call" />
        </a>

        {/* <div>
          <Button
            id="fade-button"
            className="bg-transparent border-0 p-0 ellipse-btn"
            aria-controls={open ? 'fade-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            <img src={ellipse} className="ellipse" />
          </Button>
          <Menu
            id="fade-menu"
            MenuListProps={{
              'aria-labelledby': 'fade-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
          >
            <MenuItem onClick={handleClose}>Profile</MenuItem>
          </Menu>
        </div> */}

        {/* <i className="fa-solid fa-trash-can deleteTrash"></i> */}
      </div>
    </div>
  );
};
export const MessageSendedItem = (props: MessageItemProps) => {
  const { message, image, time, media, mediaName, seen, profileImg, msgType } = props;
  return (
    <>
      <div className="our right-side-chat px-2 py-3 rounded-10 mb-4">
        <div className="chat-user-boxx">
          {msgType == '0' ? (
            message
          ) : msgType == '1' ? (
            <Image src={message} alt="image" imagefallback={placeholder} />
          ) : msgType == '2' ? (
            <video className="" width={200} height={300} controls>
              <source src={message} type={`video/${message?.split('.').pop()}`} />
            </video>
          ) : msgType == '3' ? (
            <a href={message} target="_blank" className="text-light">
              {mediaName}
            </a>
          ) : (
            ''
          )}
          <p className="text-[10px]">{time}</p>
        </div>

        <Image
          src={image}
          alt="image"
          imagefallback={profileImg ? profileImg : placeholder}
          type="img"
        />
      </div>
    </>
  );
};
export const MessageRecevedItem = (props: MessageItemProps) => {
  const { message, image, msgType, time, media, mediaName } = props;
  const docType = media?.split('.').pop()?.toString();
  return (
    <div className="there px-2 py-3 rounded-10 mb-4 d-flex gap-3 align-items-center justify-start reciver-box">
      <Image src={image} alt="image" imagefallback={placeholder} type="img" />{' '}
      <div className="recivers-msg">
        {msgType == '0' ? (
          message
        ) : msgType == '1' ? (
          <Image src={message} alt="image" imagefallback={placeholder} />
        ) : msgType == '2' ? (
          <video className="" width={200} height={300} controls>
            <source src={message} type={`video/${message?.split('.').pop()}`} />
          </video>
        ) : msgType == '3' ? (
          <a href={message} target="_blank" className="">
            {mediaName}
          </a>
        ) : (
          ''
        )}
        <p className="text-[10px]">{time}</p>
      </div>
      {/* {media && (
        <div className="recivers-msg">
          <>
            {docType == 'pdf' || docType == 'doc' || docType == 'csv' || docType == 'xlsx' ? (
              <a href={media} target="_blank">
                {mediaName}
              </a>
            ) : isVideo(media) ? (
              <video className="" width={200} height={300} controls>
                <source src={media} type={`video/${media?.split('.').pop()}`} />
              </video>
            ) : (
              <Image src={media} alt="image" imagefallback={placeholder} />
            )}
          </>
          <p className="text-[10px]">{time}</p>
        </div>
      )}
      {message && (
        <div className="recivers-msg">
          {message}
          <p className="text-[10px]">{time}</p>
        </div>
      )} */}
    </div>
  );
};
export const MessageItem = (props: MessageItemContanerProps) => {
  const { type, message, image, name, date, videoThumbnail, msgType, mediaName, seen, profileImg } =
    props;
  return type == 1 ? (
    <MessageSendedItem
      message={message}
      image={image}
      name={name}
      time={date}
      // videoThumbnail={videoThumbnail}
      msgType={msgType}
      mediaName={mediaName}
      seen={seen}
      profileImg={profileImg}
    />
  ) : (
    <MessageRecevedItem
      message={message}
      image={image}
      name={name}
      msgType={msgType}
      time={date}
      mediaName={mediaName}
    />
  );
};
export const ChatInput = (props: SendMessageInputTypes) => {
  const { handdleSendMessage } = props;
  const [mesage, setMessage] = useState('');
  const handdleSendMessageClist = () => {
    if (handdleSendMessage) handdleSendMessage(mesage);
    setMessage('');
  };
  return (
    <div className="flex flex-row items-center h-16 rounded-xl bg-white w-full px-4">
      {/* <InputEmoji
        value={mesage}
        onChange={setMessage}
        // cleanOnEnter
        onEnter={handdleSendMessageClist}
        placeholder="Type a message"
      /> */}
      <Button onClick={handdleSendMessageClist}>Send</Button>
    </div>
  );
};

export const ChatHome = () => {
  return (
    <div className="w-full h-full flex flex-col gap-4 items-center justify-center">
      <img className="w-80 h-80" src={ChatIllusttaions} alt="image" loading="lazy" />
    </div>
  );
};
